<!--商品详情-->
<template>
  <div class="news-content">
    <m-header>
      <div slot="nav"></div>
    </m-header>
    <div class="w">
      <!--产品信息-->
      <div class="item-info gray-box">
        <div class="item-title" v-if="itemTitle">
          {{ itemTitle }}
        </div>
        <div class="item-time" v-if="itemTime">
          {{ itemTime }}
        </div>
        <div class="content">
          <div class="item-content" v-if="itemDetail">
            <div v-html="itemDetail">{{ itemDetail }}</div>
          </div>
          <div class="no-info" v-else>
            <img src="/static/images/no-data.png">
            <br>
            暂无内容数据
          </div>
        </div>
      </div>
    </div>
    <m-footer></m-footer>
  </div>
</template>
<script>
  import MHeader from '/common/MHeader'
  import MFooter from '/common/MFooter'
  export default {
    data() {
      return {
        itemTitle: '',
        itemDetail: '',
        itemTime: ''
      }
    },
    methods: {
      getNewsDetail(newsId) {
        if(newsId=='00' || newsId=='01' || newsId=='02' || newsId=='03') {
          this.$api.get({
            url: '/biz/agree/' + newsId
          }).then(res=>{
            if (res.code === 200) {
              this.itemDetail = this.$yxz.showHtml(res.data.agreeContent) || '';
              this.itemTitle = res.data.agreeTitle || ''
              this.itemTime = res.data.updateTime || ''
            }
          })
        }else {
          this.$api.get({
            url: '/biz/content/' + newsId
          }).then(res=>{
            if (res.code === 200) {
              this.itemDetail = this.$yxz.showHtml(res.data.contentDetail) || '';
              this.itemTitle = res.data.contentTitle || ''
              this.itemTime = res.data.updateTime || ''
            }
          })
        }
      }
    },
    components: {
      MHeader,
      MFooter
    },
    created() {
      let agreeId = this.$route.query.agreeId
      this.getNewsDetail(agreeId)
     document.title = "医小智 - 协议"
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../assets/style/mixin";

  .news-content {
    margin: 0 auto;
  }

  .item-info {

    margin: 10px auto 10px;
    padding: 60px;

    .gray-box {
      padding: 0;
      display: block;
    }

    .item-title{
      font-size: 28px;
      color: #424242;
      text-align: center;
      padding-bottom: 20px;
    }

    .item-time{
      font-size: 14px;
      color: #999999;
      text-align: center;
      padding-bottom: 20px;
    }

    .item-content {
      width: 100%;
      text-align: center;
    }
  }

  .no-info {
    padding: 200px 0;
    text-align: center;
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// agree.vue?3f8f2224